/* import __COLOCATED_TEMPLATE__ from './device-text.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type OpampService from '../../services/opamps';

interface DeviceTextCircuitAnnotationArgs {
  item: DeviceItem;
  r: string;
  c: string;
  matrix: string;
}

type DeviceItem = {
  name: string;
  url: string;
  tolerance: string;
};

export default class DeviceTextCircuitAnnotation extends Component<DeviceTextCircuitAnnotationArgs> {
  @service('aditools-site') declare siteconfig: SiteService;
  @service declare intl: IntlService;
  @service declare opamps: OpampService;

  get url(): string {
    return this.args.item.url
      ? this.args.item.url
      : this.args.item.name
        ? `${this.siteconfig['SiteUrl']}/${this.siteconfig.AdiLocale}/${this.opamps
            .getOpAmp(this.args.item.name)
            .generic.toUpperCase()}`
        : '';
  }

  get name(): string {
    return this.args.item.name
      ? this.args.item.name.toUpperCase()
      : this.intl.t('settings.components.choose-op-amp').toString();
  }

  get hasUrl(): boolean {
    return this.url.length > 0;
  }

  get hasChannel(): boolean {
    return this.args.c !== undefined && this.args.c !== null && this.args.c !== '';
  }

  get channel(): string {
    return this.args.c;
  }

  get value(): string {
    return this.args.r;
  }
}
